<!-- eslint-disable max-len -->
<template>
  <div>
    <Card
      :title="'Artist Bio Management'"
    >
      <template v-slot:body>
        <div class="pb-6 flex justify-between items-center">
          <div class="flex items-center">
            <div class="mr-2">
              <el-input placeholder="search name" v-model="filter" @change="search" ></el-input>
            </div>
            <Button @clicked="search" label="Apply"/>
            <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="reset" /></button>
          </div>
        </div>
        <data-tables-server ref="tableArtist" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [20,50,100,300,500] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom" :width="title.prop.width">
          </el-table-column>
          <el-table-column v-if="isSuperAdmin || isAdmin || isOps" label="Actions" align="right" width="auto">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip label="Approve" :position="'is-left'">
                  <button @click="approvalBio(scope.row,true)" class="p-2 w-8 mr-2 rounded bg-green-500 hover:bg-green-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'check']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip label="Detail" :position="'is-left'">
                  <button @click="detail(scope.row)" class="p-2 w-8 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip label="Edit" :position="'is-left'">
                  <button @click="editBio(scope.row)" class="p-2 w-8 mr-2 rounded bg-orange-500 hover:bg-orange-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                  </button>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
    <ModalDialog
      ref="editBio"
      :isShowingModal="isShowingModalEdit"
      :isLoading="isLoading"
      :error="isError"
      labelSubmit="Save"
      title="Edit Bio"
      @toggleModal="isShowingModalEdit=!isShowingModalEdit"
      @save="submitEditBio(artist)"
    >
      <template slot="body">
        <div class="py-6" style="min-width: 560px">
          <form-item label='Artist Name'>
            <p class="text-left font-bold">{{ artist.name }}</p>
          </form-item>
          <form-item label='Bio'>
            <template v-slot>
              <div class="relative" >
                <TextArea
                  v-model="artist.bio"
                  placeholder="Bio"
                  :maxlength="maxLengthBio"
                  rows="10"
                />
                <div  class="absolute right-0 text-xs" style="bottom: 15px; right: 15px;" >{{artist.bio.length}}/{{maxLengthBio}}</div>
              </div>
            </template>
          </form-item>
        </div>
      </template>
    </ModalDialog>
    <ModalDialogDetail
      ref="detailBio"
      :isShowingModal="isShowingModalDetail"
      :isLoading="isLoading"
      title="Bio Details"
      @toggleModal="isShowingModalDetail = !isShowingModalDetail"
    >
      <template slot="body" >
        <div class="py-6" style="min-width: 360px">
          <form-item label='Artist Name'>
            <p class="text-left font-bold">{{ artist.name }}</p>
          </form-item>
          <form-item label='Bio'>
            <p class="text-left font-bold">{{ artist.bio }}</p>
          </form-item>
        </div>
      </template>
    </ModalDialogDetail>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import ModalDialog from '@/components/Common/ModalDialog';
import ModalDialogDetail from '@/components/Common/ModalDialogDetail';
import Card from '@/components/Layout/Card.vue';
import { Button, FormItem, Input, TextArea, TextError } from '@/components/Layout/Form';

const limit = 20;
export default {
  name: 'ArtistsBioPage',
  data() {
    return {
      maxLengthBio: 2000,
      isLoading: false,
      isError: false,
      isShowingModalEdit: false,
      isShowingModalDetail: false,
      data: [],
      total: 0,
      page: 1,
      titles: [{
        prop: {
          field: 'name',
          width: 'auto',
        },
        label: 'Name',
      }, {
        prop: {
          field: 'bioText',
          width: 'auto',
        },
        label: 'Bio',
      }],
      filter: '',
      filterParam: {
        per_page: limit,
        q: '',
      },
      selectedRow: [],
      artist: {
        id: '',
        name: '',
        bio: '',
      },
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListArtistBio(this.filterParam);
    // this.refineData();
  },
  computed: {
    ...mapGetters('NotificationModule', ['isLoading']),
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isFinance', 'isOps']),
    ...mapGetters('ArtistModule', ['listArtistBio']),
  },
  watch: {
    listArtistBio: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.refineData();
      },
    },
  },
  methods: {
    ...mapActions('ArtistModule', ['requestListArtistBio', 'requestEditBio', 'requestApprovalBio',
    ]),
    async search() {
      this.filterParam.q = this.filter;
      await this.requestListArtistBio(this.filterParam);
      // this.refineData();
    },
    async reset() {
      this.$refs.tableArtist.$refs.elTable.clearSort();
      this.filter = '';
      this.filterParam.q = '';
      this.search();
    },
    refineData() {
      if (this.listArtistBio.data !== undefined) {
        this.total = this.listArtistBio.data.total;
        this.data = this.listArtistBio.data.data.map((v) => {
          const bioText = v.bio.length > 800 ? `${v.bio.substring(0, 799)}...` : v.bio;
          return { ...v, bioText };
        });
      }
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      this.page = page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filterParam = { ...this.filterParam, per_page: this.displayingItem, q: this.filter, sortorder, sortby, page };
      await this.requestListArtistBio(this.filterParam);
    },

    async approvalBio(row, approval) {
      Vue.swal({
        title: 'Bio Approval',
        text: `Are you sure to approve bio artist: ${row.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          const data = { id: row.id, approved: approval };
          const filter = this.filterParam;
          await this.requestApprovalBio({ data, filter });
          this.$swal('Approved', `You successfully approve bio artist: ${row.name}`, 'success');
        }
      });
    },
    async editBio(row) {
      this.isShowingModalEdit = true;
      this.artist = { ...this.artist,
        id: row.id,
        name: row.name,
        bio: row.bio,
      };
    },
    async detail(row) {
      this.isShowingModalDetail = true;
      this.artist = { ...this.artist,
        id: row.id,
        name: row.name,
        bio: row.bio,
      };
    },
    async submitEditBio(artist) {
      try {
        const filter = this.filterParam;
        const data = artist;
        await this.requestEditBio({ data, filter });
        this.isShowingModalEdit = false;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
  },
  components: { ModalDialog, ModalDialogDetail, Card, FormItem, Input, TextError, Button, TextArea, },
};
</script>
<style scoped>
.el-table{
  min-height: 400px;
}

</style>



// WEBPACK FOOTER //
// src/views/ArtistBio.vue